import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { authGuard } from './shared/auth.guard';
import { RoutesWithData } from './shared/constants-and-enums/route-data';
import { BreadcrumbItem } from './store/reducer/breadcrumb.reducer';
import { VersionInformationComponent } from './version-information/version-information.component';

const ADMIN_BREADCRUMB: BreadcrumbItem = { text: $localize`Admin`, onClick: '/admin' };

const routes: RoutesWithData = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
        canActivate: [authGuard],
        path: 'administration',
        loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule)
    },
    {
        data: { breadcrumb: { text: $localize`Case Management`, onClick: '/reimbursement' } },
        canActivate: [authGuard],
        path: 'reimbursement',
        loadChildren: () => import('./reimbursement/reimbursement.module').then((m) => m.ReimbursementModule)
    },
    {
        data: { breadcrumb: { text: $localize`Employees`, onClick: '/employees' } },
        canActivate: [authGuard],
        path: 'employees',
        loadChildren: () => import('./employee/employee.module').then((m) => m.EmployeeModule)
    },
    {
        data: { breadcrumb: { text: $localize`Dashboard`, onClick: '/dashboard' } },
        canActivate: [authGuard],
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule)
    },
    {
        data: { breadcrumb: ADMIN_BREADCRUMB },
        canActivate: [authGuard],
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule)
    },
    {
        data: { breadcrumbs: [ADMIN_BREADCRUMB, { text: $localize`Media Assets`, onClick: '/media-assets' }] },
        canActivate: [authGuard],
        path: 'media-assets',
        loadChildren: () => import('./media-assets/media-assets.module').then((m) => m.MediaAssetsModule)
    },
    {
        data: { breadcrumbs: [ADMIN_BREADCRUMB, { text: $localize`Version`, onClick: '/version-information' }] },
        canActivate: [authGuard],
        path: 'version-information',
        component: VersionInformationComponent
    },
    {
        data: { breadcrumb: { text: $localize`INH Billing`, onClick: '/billing' } },
        canActivate: [authGuard],
        path: 'billing',
        loadChildren: () => import('./billing/billing.module').then((m) => m.BillingModule)
    },
    {
        data: { breadcrumb: { text: $localize`Reporting`, onClick: '/reporting' } },
        canActivate: [authGuard],
        path: 'reporting',
        loadChildren: () => import('./reporting/reporting.module').then((m) => m.ReportingModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
